export const isUint8Array = (value) => {
  return value instanceof Uint8Array
}
